/* ==========================================================================
   La Cantona — rotación automática de imágenes en las tarjetas de producto
   - Un temporizador por tarjeta, no uno global.
   - Solo rota lo que está visible en pantalla (IntersectionObserver).
   - Se para al pasar el ratón, al enfocar con teclado y con la pestaña oculta.
   - Respeta "reducir movimiento" del sistema.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function CardSlider(el) {
    this.el = el;
    this.slides = Array.prototype.slice.call(el.querySelectorAll('.card-slider__slide'));
    this.index = 0;
    this.timer = null;
    this.visible = false;
    this.paused = false;
    this.interval = parseInt(el.dataset.interval, 10) || 3000;

    if (this.slides.length < 2) return;

    el.classList.add('is-ready');
    this.slides.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === 0);
    });

    this.bind();
    this.observe();
  }

  CardSlider.prototype.bind = function () {
    var self = this;
    var card = this.el.closest('.card-wrapper') || this.el;

    ['mouseenter', 'focusin'].forEach(function (evt) {
      card.addEventListener(evt, function () {
        self.paused = true;
        self.stop();
      });
    });

    ['mouseleave', 'focusout'].forEach(function (evt) {
      card.addEventListener(evt, function () {
        self.paused = false;
        self.start();
      });
    });
  };

  CardSlider.prototype.observe = function () {
    var self = this;

    if (!('IntersectionObserver' in window)) {
      this.visible = true;
      this.start();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          self.visible = entry.isIntersecting;
          if (self.visible) {
            self.start();
          } else {
            self.stop();
          }
        });
      },
      { rootMargin: '100px' }
    );

    observer.observe(this.el);
  };

  CardSlider.prototype.start = function () {
    if (this.timer || !this.visible || this.paused || REDUCED_MOTION.matches) return;
    var self = this;
    this.timer = window.setInterval(function () {
      self.next();
    }, this.interval);
  };

  CardSlider.prototype.stop = function () {
    if (!this.timer) return;
    window.clearInterval(this.timer);
    this.timer = null;
  };

  CardSlider.prototype.next = function () {
    this.slides[this.index].classList.remove('is-active');
    this.index = (this.index + 1) % this.slides.length;
    this.slides[this.index].classList.add('is-active');
  };

  var instances = [];

  function init(root) {
    (root || document).querySelectorAll('[data-card-slider]').forEach(function (el) {
      if (el.dataset.cardSliderReady === 'true') return;
      el.dataset.cardSliderReady = 'true';
      instances.push(new CardSlider(el));
    });
  }

  function onReady() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  // Pausar todo cuando la pestaña no está a la vista.
  document.addEventListener('visibilitychange', function () {
    instances.forEach(function (slider) {
      if (document.hidden) {
        slider.stop();
      } else {
        slider.start();
      }
    });
  });

  // Contenido cargado después: filtros de colección, carga paginada,
  // y el editor de temas al reordenar o recargar una sección.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      var needsInit = mutations.some(function (m) {
        return m.addedNodes.length > 0;
      });
      if (needsInit) init(document);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
